import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a3912e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

import reportParameterListComponent from "@/components/reports/parameter/reportParameterListStation.component.vue";
import reportParameterFilterComponent from "@/components/reports/parameter/reportParameterFilterStation.component.vue";
import { ReportParameterStation } from "@/types/report.type";
import { ref } from "vue";
import { downloadReportParameters, getReportParameters } from "@/service/reportStation.service";
import { downloadFile } from "@/utils/blob.util";
import { Pagination, paginationResultDefault } from "@/types/pagination.type";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore<RootState>();

// - form
const formCmp = ref<InstanceType<typeof reportParameterFilterComponent> | null>(null);
const parametersResult = ref<Pagination<ReportParameterStation> | null>(paginationResultDefault);

// - pagination
const page = ref(1);
const size = ref(10);

// - METHODS
/**
 * change page
 * @param v
 */
const changePage = async (v: number) => {
  page.value = v;
  await fetchData();
};

/**
 * change size
 * @param v
 */
const changeSize = async (v: number) => {
  size.value = v;
  await fetchData();
};

/**
 * show preview
 */
const showPreview = async () => {
  page.value = 1;
  await fetchData();
};

/**
 * fetchData
 */
const fetchData = async () => {
  if (!formCmp.value || !formCmp.value.reportFilter || !(await formCmp.value.validate())) {
    parametersResult.value = null;
    return;
  }

  if (
    formCmp.value.reportFilter.date &&
    formCmp.value.reportFilter.date[0] !== null &&
    formCmp.value.reportFilter.date[1] !== null
  ) {
    if (
      moment(formCmp.value.reportFilter.date[0]).isSame(moment(formCmp.value.reportFilter.date[1]))
    ) {
      formCmp.value.reportFilter.date[1].setTime(
        formCmp.value.reportFilter.date[1].getTime() + 86400000
      );
    }
  }
  parametersResult.value = await getReportParameters(
    page.value,
    size.value,
    formCmp.value.reportFilter,
    store.state.ui.timeZone
  );
};

/**
 * download CSV
 */
const downloadCSV = async () => {
  await fetchData();
  if (!formCmp?.value?.reportFilter) return;

  const data = await downloadReportParameters(formCmp.value.reportFilter, store.state.ui.timeZone);
  downloadFile(data.url, data.fileName);
};

const isDisabled = () => {
  return (
    formCmp?.value?.reportFilter.date === undefined ||
    (formCmp?.value?.reportFilter.date[0] === null &&
      formCmp?.value?.reportFilter.date[1] === null) ||
    (formCmp?.value?.reportFilter.date[0] !== null &&
      formCmp?.value?.reportFilter.date[1] !== null &&
      formCmp?.value?.reportFilter.date[0] > formCmp?.value?.reportFilter.date[1])
  );
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "header-import page-title" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("title.generateReport")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "app-main-full-height-lg-and-up" }, {
              default: _withCtx(() => [
                _createVNode(reportParameterFilterComponent, {
                  ref_key: "formCmp",
                  ref: formCmp
                }, null, 512),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showPreview())),
                  disabled: isDisabled()
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("btn.preview")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadCSV())),
                  disabled: isDisabled()
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("btn.downloadCSV")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "app-main-full-height-lg-and-up" }, {
              default: _withCtx(() => [
                _createVNode(reportParameterListComponent, {
                  pagination: parametersResult.value,
                  onChangePage: _cache[2] || (_cache[2] = ($event: any) => (changePage($event))),
                  onChangeSize: _cache[3] || (_cache[3] = ($event: any) => (changeSize($event)))
                }, null, 8, ["pagination"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})